export default __webpack_public_path__ + "static/media/pt-icon-active.18afac0f.svg";